import React from "react";

const PreSectionMessageBox = () => {
    return <div className="thirdPartyClientPreSectionMessageBox">
        The pre-selection of clients is based on the technical setup of the property licence.
    </div>
};

export default PreSectionMessageBox;
